import { Component, OnInit } from '@angular/core';
import { DistribuidorDeContenidosService } from '../servicio/distribuidor-de-contenidos.service'

@Component({
  selector: 'app-portada',
  templateUrl: './portada.component.html',
  styleUrls: ['./portada.component.css']
})
export class PortadaComponent implements OnInit {

  titulo: string
  logo: string
  fondo: string

  constructor(private distribuidor: DistribuidorDeContenidosService) {
    this.titulo = this.distribuidor.contenidoPortada.titulo;
    this.fondo = this.distribuidor.contenidoPortada.fondo;
    this.logo = this.distribuidor.contenidoPortada.logo;
  }

  ngOnInit(): void {

  }

}
